import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ControlContainer, FormGroupDirective, UntypedFormControl, Validators } from '@angular/forms';
import { InputStepComponent } from '../../step/input-step/input-step.component';

/**
 * FRU-24835: the reverse flow's first question. A reverse mortgage needs every borrower to be 62 or older, so the youngest
 * borrower's age decides it. Under 62 stops here with a pointer to the home equity options; nothing is submitted.
 */
@Component({
    selector: 'app-reverse-age',
    templateUrl: './reverse-age.component.html',
    styleUrls: ['./reverse-age.component.scss', '../../step/step.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
    standalone: false
})
export class ReverseAgeComponent extends InputStepComponent implements OnInit {
  title = 'How old is the youngest person who would be on the loan?';
  subtitle = 'Reverse mortgages are for homeowners 62 and older.';
  tooYoung = false;

  @ViewChild('age') ageField: ElementRef;

  ngOnInit() {
    this.control = this.form.contains('title_holder_age')
      ? this.form.get('title_holder_age') as UntypedFormControl
      : new UntypedFormControl('');
    this.control.setValidators([Validators.required, Validators.pattern(/^\d{2,3}$/), Validators.max(110)]);
    this.control.updateValueAndValidity();
    if (!this.form.contains('title_holder_age')) { this.form.addControl('title_holder_age', this.control); }
    if (!this.form.contains('aged_sixty_two')) { this.form.addControl('aged_sixty_two', new UntypedFormControl('')); }
  }

  /** Any edit undoes the last answer: the stop goes away, and the 62+ answer is unknown again until Continue, so browser Forward
   *  can't carry an earlier eligible answer past a changed age. */
  ageChanged() {
    this.tooYoung = false;
    this.form.get('aged_sixty_two')?.setValue('');
  }

  initStep() {
    setTimeout(() => this.ageField?.nativeElement.focus(), 0);
  }

  submit() {
    this.control.markAsTouched();
    if (this.control.status === 'INVALID') {
      super.submit();
      return;
    }
    const age = Number(this.control.value);
    this.form.get('aged_sixty_two').setValue(age >= 62 ? 'yes' : 'no');
    if (age < 62) {
      this.tooYoung = true;
      this.analyticsService.trackEvent('RatesForm', 'reverse_under_62', 'reverse');
      return;
    }
    this.tooYoung = false;
    this.control.setValue(age);
    super.submit();
  }
}
